import 'swiper/css/bundle';
import Swiper from 'swiper/bundle';

var swiper = new Swiper('.swiper__update', {
    slidesPerView: 2,
    autoplay: {
        pauseOnMouseEnter: true,
    },
    pagination: {
        el: '.swiper-pagination',
        dynamicBullets: true,
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        768: {
            slidesPerView: 3,
        },
    },
});

var swiper = new Swiper('.swiper__gallery', {
    loop: true,
    centeredSlides: true,
    centeredSlidesBounds: true,

    spaceBetween: 10,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    autoplay: {
        pauseOnMouseEnter: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        768: {
            spaceBetween: 20,
            slidesPerView: 2,
        },
    },
});
